import { render, staticRenderFns } from "./DashboardSessions.vue?vue&type=template&id=2bda72c0&scoped=true&"
import script from "./DashboardSessions.vue?vue&type=script&lang=js&"
export * from "./DashboardSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda72c0",
  null
  
)

export default component.exports